import { BackOfficeContent } from 'app/agriculture/routes/BackOffice/BackOfficeContent';
import { FarmCardsSkeleton } from './components/FarmCards/FarmCardsSkeleton';
import { TitleSkeleton } from 'app/agriculture/components/Title/TitleSkeleton';
import { SubtitleSkeleton } from 'app/agriculture/components/Subtitle/SubtitleSkeleton';

function UserHomeSkeleton() {
    return (
        <BackOfficeContent>
            <TitleSkeleton />
            <SubtitleSkeleton />
            <FarmCardsSkeleton />
        </BackOfficeContent>
    );
}

export { UserHomeSkeleton };
